import React, { useContext, useEffect, useState } from "react";
import { CurrentUserContext } from "../../../App";
import * as api from "../../../service/patientApiDev";
import { HashLoader } from "react-spinners";
import styles from "./pagePatient.module.css";
import { useNavigate } from "react-router-dom";
import iconSuccess from "../../../asset/icon/success.svg";
import Button from "../../material/button/Button";

export default function UpLevelByMohPromt() {
  const { setIsMessage } = useContext(CurrentUserContext);

  const navigate = useNavigate();

  const user = JSON.parse(localStorage.getItem("user"));

  const [loading, setLoading] = useState(false);
  const [loadingSuccess, setLoadingSuccess] = useState(false);

  const [role, setRole] = useState("");

  useEffect(() => {
    getParameter();
    setRole(user["auth"]["role"][0]);
  }, []);

  const getParameter = () => {
    let url = decodeURIComponent(window.location.href);
    let newUrl = new URL(url);
    let data = newUrl.searchParams;

    if (data.get("code")) {
      upLevelMohPromt(data.get("code"));
    } else {
      setIsMessage({ type: "warning", data: "code is require." });
    }
  };

  const upLevelMohPromt = async (code) => {
    setLoading(true);
    let res = await api.updateMohPromtIAL(code);
    setLoading(false);

    if (res) {
      if (res["data"]["code"] === 200) {
        setLoadingSuccess(true);
      } else if (res["data"]["code"] === 404) {
        if (role === "PATIENT") {
          navigate("/manageinfo", {
            state: {
              status_message: "Error",
              display_message: "ไม่พบข้อมูลผู้ใช้งาน",
            },
          });
        } else if (role === "MEDICAL_PERSONNEL") {
          navigate("/doctor/ManageInfo", {
            state: {
              status_message: "Error",
              display_message: "ไม่พบข้อมูลผู้ใช้งาน",
            },
          });
        } else if (
          role === "LABORATORY_ADMIN" ||
          role === "LABORATORY_PERSONNEL"
        ) {
          navigate("/laboratory/manageprofileOperation", {
            state: {
              status_message: "Error",
              display_message: "ไม่พบข้อมูลผู้ใช้งาน",
            },
          });
        } else {
          setIsMessage({
            type: "error",
            data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
          });
        }

        //setIsMessage('ไม่พบข้อมูลผู้ใช้งาน กรุณาสมัครใช้งานก่อน')
      } else {
        if (role === "PATIENT") {
          navigate("/manageinfo", {
            state: {
              status_message: "Error",
              display_message:
                res["data"]["message_th"] || res["data"]["message"],
            },
          });
        } else if (role === "MEDICAL_PERSONNEL") {
          navigate("/doctor/ManageInfo", {
            state: {
              status_message: "Error",
              display_message:
                res["data"]["message_th"] || res["data"]["message"],
            },
          });
        } else if (
          role === "LABORATORY_ADMIN" ||
          role === "LABORATORY_PERSONNEL"
        ) {
          navigate("/laboratory/manageprofileOperation", {
            state: {
              status_message: "Error",
              display_message:
                res["data"]["message_th"] || res["data"]["message"],
            },
          });
        } else {
          setIsMessage({
            type: "error",
            data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
          });
        }

        //setIsMessage(res['data']['message_th'] || res['data']['message'])
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  return (
    <div className={styles.align}>
      {loading ? <Loading loading={loading} /> : ""}
      {loadingSuccess ? (
        <Success
          loading={loadingSuccess}
          role={role}
          setIsMessage={setIsMessage}
        />
      ) : (
        ""
      )}
    </div>
  );
}

const Loading = ({ loading }) => {
  return (
    <>
      <div className={styles.wait}>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <HashLoader loading={loading} color="#FF9768" />
        </div>
        <div className={styles.font}>
          <div className={styles.Orange}>กำลังตรวจสอบข้อมูล</div>
          <div className={styles.Orange}>กรุณารอสักครู่</div>
        </div>
      </div>
    </>
  );
};

const Success = ({ role, setIsMessage }) => {
  const [counter, setCounter] = useState(10);
  const navigate = useNavigate();

  const clickNavigate = () => {
    if (role === "PATIENT") {
      navigate("/manageinfo");
    } else if (role === "MEDICAL_PERSONNEL") {
      navigate("/doctor/ManageInfo");
    } else if (role === "LABORATORY_ADMIN" || role === "LABORATORY_PERSONNEL") {
      navigate("/laboratory/manageprofileOperation");
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  useEffect(() => {
    CountNumber();
  }, [counter]);

  const CountNumber = () => {
    counter > 0 && setTimeout(() => setCounter(counter - 1), 1000);
    if (counter === 0) {
      if (role === "PATIENT") {
        navigate("/manageinfo");
      } else if (role === "MEDICAL_PERSONNEL") {
        navigate("/doctor/ManageInfo");
      } else if (
        role === "LABORATORY_ADMIN" ||
        role === "LABORATORY_PERSONNEL"
      ) {
        navigate("/laboratory/manageprofileOperation");
      } else {
        setIsMessage({
          type: "error",
          data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
        });
      }
    }
  };
  return (
    <>
      <div className={styles.success}>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <img src={iconSuccess} />
        </div>
        <div className={styles.font}>
          <div className={styles.Orange}>พิสูจน์ตัวตนสำเร็จ</div>
          <div className={styles.Gray}>
            ระบบจะพาไปยังหน้า “จัดการข้อมูลส่วนตัว” ภายใน {counter} วินาที
          </div>
        </div>
        <div style={{ width: "70%", margin: "auto" }}>
          <Button
            style={{ background: "#FF9768", color: "#FFFFFF", border: "none" }}
            onClick={clickNavigate}
          >
            ไปหน้า จัดการข้อมูลส่วนตัว
          </Button>
        </div>
      </div>
    </>
  );
};
